<div class="progress_list_wrapper secondary-text-colour">
  <div class="progress_list">
    @for (
      searchObject of page === pageType.Itinerary || page === pageType.GetMeThere
        ? basketItemTypes
        : (searchService.search_objects | selectedSearchObject);
      track searchObject;
      let last = $last
    ) {
      <div
        class="progress_list_item"
        [attr.aria-current]="
          (searchObject | replaceUnderscore | lowercase) === resultsType ? 'step' : null
        "
        [class.active-search-type]="(searchObject | replaceUnderscore | lowercase) === resultsType"
      >
        <div>
          @if (getIconClass | memoize: searchObject; as iconClass) {
            <i aria-hidden="true" class="travel_icon {{ iconClass }}"></i>
          }
          @if (searchObject !== 'airportexpress' && page !== pageType.GetMeThere) {
            <span class="travel_icon_txt">{{
              searchObject | replaceUnderscore | titlecase | translate
            }}</span>
          }
          @if (searchObject === 'airportexpress') {
            <span class="travel_icon_txt" i18n="@@resultsHeaderAirportExpress"
              >Airport Express</span
            >
          }
          <div
            class="icon-separator"
            aria-hidden="true"
            [style.display]="last && !valid ? 'none' : 'block'"
            [ngClass]="{ 'gmt-icon-separator': page === pageType.GetMeThere }"
          ></div>
        </div>
      </div>
    }
    @if (valid) {
      <div
        class="progress_list_item progress_list_item--confirm"
        [attr.aria-current]="page === pageType.Itinerary ? 'step' : null"
        [class.active-search-type]="page === pageType.Itinerary"
      >
        <div>
          <i class="ico-check-1 travel_icon" aria-hidden="true"></i>
          @if (page !== pageType.GetMeThere) {
            <span class="travel_icon_txt" i18n="@@resultsHeaderConfirm">Confirm</span>
          }
        </div>
      </div>
    }
  </div>
</div>
